import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    bg: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px dashed',
    borderBottomColor: 'blackAlpha.300',
    borderTop: '1px dashed',
    borderTopColor: 'whiteAlpha.200',
    py: '2',
    pl: '3',
    pr: '2',
    _hover: {
      textDecoration: 'none',
    },
    _last: {
      mb: 0,
    },
  },
  textCompetitionName: {
    color: 'white',
    fontFamily: 'accent',
    fontWeight: 'normal',
    fontSize: 'xs',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
  },
  textMatchCount: {
    px: '1',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
};
